import React, { useState } from "react";
import CustomInput from "../../customComponents/CustomInput/CustomInput";
// import landingpageimage from "./../../../Assets/images/landingPage.svg";
import loginLogo from "./../../../Assets/icons/logo-newtron-green.svg";
import backicon from "./../../../Assets/icons/Group 1707478226.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../services/api/API";
import { showAlert } from "../../customComponents/CustomSweetAlert/ShowAlert";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // New state for loading

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Start loading

    // Basic validation
    if (!email) {
      setError("Please enter email");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post("/forgot-password", {
        email,
      });

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Password reset link sent on your mail successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        setError(
          "Failed to log in. Please check your credentials and try again."
        );
      }
    } catch (error) {
      // catch (error) {
      //   console.error("Error logging in:", error);
      //   setError(error.response.data.message || "An error occurred. Please try again later.");
      // }
      console.error("Error logging in:", error?.response?.data?.data?.message);

      const errorMessage =
       error?.response?.data?.data?.message ||
        "An error occurred. Please try again later.";

      await showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });

      setError(errorMessage);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const navigate = useNavigate();

  return (
    <>
      <div className="mainContainer">
        <div className="parentContainer">
          <div className="loginImage">
            <img
              style={{ height: "21rem", width: "20rem", objectFit: "contain" }}
              src={loginLogo}
              alt="Login"
              className="img-fluid"
            />
          </div>
          <div className="loginContainer">
            <h3 className="mb-3">Forgot Password?</h3>
            <form onSubmit={handleChangePassword}>
              <p className="resetpasstitle mb-3">
                Kindly provide your email address. We'll send a verification
                code to facilitate password reset on your registered email.
              </p>
              <div className="loginInputsContainer">
                <CustomInput
                  type="email"
                  value={email}
                  autoComplete="off"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mt-3">
                <button className="loginButton">Submit</button>
              </div>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
                className="backtologin mt-3"
              >
                <img src={backicon} alt="back" /> <span>Back To Login</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;
